import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { ShowWindowMessage } from "src/common/userMainWindow/userMainWindow-viewModel";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { TransactionCreationViewModel } from "../transactionCreation/transactionCreation-viewModel";
import { TransactionDetailViewModel } from "./transactionDetail/transactionDetail-viewModel";
import { TransactionListView } from "./transactionList-view"
import { translate } from "src/common/utilities";
import { downloadFile } from "src/uicomponents/components/utilities";

export class TransactionListViewModel extends WindowViewModel {

    public getTitle(): string {
        return translate("transactionList-viewModel.documentsList", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.transactions = ObservableArray.create<SingleTransaction>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new TransactionListView();
    }
    public getTypeId(): string {
        return "VM-25648DC8-EB11-44FF-B933-7DD0D4F41E08"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set transactions(v: ObservableArray<SingleTransaction>) { this._transactions = v; } public get transactions(): ObservableArray<SingleTransaction> { return this._transactions; } private _transactions: ObservableArray<SingleTransaction>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;

    refresh() {
        this.loader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("Complex/AccountingServices/LoadAllTransactions", { FurtherQueryInfo: filteringInformation });
            var parser = new TransactionParser();
            this.transactions.update(...parser.parseList(result.Transactions, this));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    addNewTransaction() {
        this.handleMessage(new ShowWindowMessage(p => new TransactionCreationViewModel(p)));
    }

    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AccountingServices/TransactionsExport',{
            });
            downloadFile(result.ExcelFile, `Transactions.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}


export class TransactionParser {
    public parseSingle(transactionDto: any, parent: ViewModel): SingleTransaction {
        let transaction = new SingleTransaction(parent);
        transaction.id = transactionDto.Id;
        transaction.name = transactionDto.Name;
        transaction.amount = transactionDto.Amount;
        transaction.currencyName = transactionDto.AmountCurrencyName;
        transaction.crossReferenceCode = transactionDto.CrossReferenceCode;
        transaction.description = transactionDto.Description;
        transaction.time = moment.utc(transactionDto.Time);
        transaction.code = transactionDto.TransactionCode;
        transaction.entries.update(...transactionDto.Entries.map(q => {
            let entry = new SingleEntryInTransaction(transaction);
            entry.amount = Math.abs(q.Amount);
            entry.hasCredit = q.Amount < 0;
            entry.description = q.Description;
            entry.currencyName = q.CurrencyName;
            entry.index = q.Order;
            entry.accountsPath.update(...q.Account.map(z => {
                let account = new singleAccountInPath(entry);
                account.id = z.AccountId;
                account.name = z.AccountName;
                account.code = z.AccountCode;
                return account;
            }));
            entry.accountPathString = entry.accountsPath.map(q => `${q.name} (${q.code})`).join(' / ');
            entry.details.update(...q.DetailValues.map(z => {
                let d = new singleDetailForEntry(entry);
                d.detailId = z.AccountDetailId;
                d.detailName = z.AccountDetailName;
                d.valueId = z.DetailValueId;
                d.valueName = z.DetailValueName;
                return d;
            }));
            return entry;
        }));
        return transaction;

    }
    public parseList(transactions: any[], parent: TransactionListViewModel): SingleTransaction[] {
        return transactions.map((x, i) => {
            let r = this.parseSingle(x, parent);
            r.index = i + 1;
            return r;
        });
    }
}

export class SingleTransaction extends ViewModel {
    public getTypeId(): string { return 'singleTransaction'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this._parent = parent;
        this.entries = ObservableArray.create<SingleEntryInTransaction>();
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName; } private _currencyName: string;
    public set crossReferenceCode(v: string) { this._crossReferenceCode = v; } public get crossReferenceCode(): string { return this._crossReferenceCode; } private _crossReferenceCode: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time; } private _time: moment.Moment;
    public set entries(v: ObservableArray<SingleEntryInTransaction>) { this._entries = v; } public get entries(): ObservableArray<SingleEntryInTransaction> { return this._entries; } private _entries: ObservableArray<SingleEntryInTransaction>;

    private _parent: ViewModel;
    async remove() {
        let result: string = 'yes';
        result = await this.messageBoxWarningYesNo(translate("transactionList-viewModel.removeQuestion", {}), translate("transactionList-viewModel.removeDocument", {}));
        if (result == 'yes') {
            let result = await ServerConnection.callServer('Complex/AccountingServices/DeleteTransaction', {
                TransactionId: this.id
            });
            if (result.IsSuccessful == false) {
                throw "Failed";
            } else {
                result = await this.messageBoxConfirmSuccess(translate("transactionList-viewModel.removeSuccessfully",{}), translate("transactionList-viewModel.remove",{}));
                this.requestRefreshWindow();
            }
        }
    }

    showDetail() {
        let popup = new TransactionDetailViewModel(this);
        popup.loadByVm(this);
        this.requestShowingPopup(popup)
    }
    async edit() {
        let editor = new TransactionCreationViewModel(this);
        editor.loadById(this.id);
        let isChanging = await this.requestShowingPopup(editor);
        if (isChanging == 'yes') {
            this.requestRefreshWindow();
        }
    }
}

export class SingleEntryInTransaction extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.accountsPath = ObservableArray.create<singleAccountInPath>();
        this.details = ObservableArray.create<singleDetailForEntry>();
        this.isExpanded = false;
    }

    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName; } private _currencyName: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set accountsPath(v: ObservableArray<singleAccountInPath>) { this._accountsPath = v; } public get accountsPath(): ObservableArray<singleAccountInPath> { return this._accountsPath; } private _accountsPath: ObservableArray<singleAccountInPath>;
    public set details(v: ObservableArray<singleDetailForEntry>) { this._details = v; } public get details(): ObservableArray<singleDetailForEntry> { return this._details; } private _details: ObservableArray<singleDetailForEntry>;
    public set accountPathString(v: string) { this._accountPathString = v; } public get accountPathString(): string { return this._accountPathString; } private _accountPathString: string;
    public set hasCredit(v: boolean) { this._hasCredit = v; } public get hasCredit(): boolean { return this._hasCredit; } private _hasCredit: boolean;
    public set isExpanded(v: boolean) { this._isExpanded = v; } public get isExpanded(): boolean { return this._isExpanded; } private _isExpanded: boolean;

    switchExpand() {
        this.isExpanded = !this.isExpanded;
    }
}
export class singleDetailForEntry extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set detailId(v: string) { this._detailId = v; } public get detailId(): string { return this._detailId; } private _detailId: string;
    public set detailName(v: string) { this._detailName = v; } public get detailName(): string { return this._detailName; } private _detailName: string;
    public set valueId(v: string) { this._valueId = v; } public get valueId(): string { return this._valueId; } private _valueId: string;
    public set valueName(v: string) { this._valueName = v; } public get valueName(): string { return this._valueName; } private _valueName: string;
}
export class singleAccountInPath extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;

}